interface Props {
  size?: 'md' | 'lg';
  label?: string;
}

export const Spinner = ({ size = 'md', label }: Props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }} role="status" aria-live="polite">
      <div className={size === 'lg' ? 'spinner spinner--lg' : 'spinner'} />
      {label ? <span className="spinner-label">{label}</span> : null}
    </div>
  )
}
